export const ExternalUrls = {
  AuthenticatorQrCode: (secret, label = process.env.AUTHENTICATOR_LABEL) =>
    `otpauth://totp/${encodeURIComponent(label)}?secret=${encodeURIComponent(
      secret
    )}`,
};
